export default {
  'initiateForm.limitsRemaining': 'Limit remaining',
  'initiateForm.overBy': ' OVER BY',
  'initiateForm.totalPayments': 'TOTAL (<%= numberOfPayments %>) PAYMENTS',
  'initiateForm.exceedCustomerOverallMessage':
    'Total Transaction(s) exceeds your daily Shared Customer Limit for <%= modifiedTransactionDate %>',
  'initiateForm.exceedUserOverallMessage':
    'Total Transaction(s) exceeds your daily  User Overall  Limit for <%= modifiedTransactionDate %>',

  'initiateForm.exceedCustomerCompanyMessage':
    '(<%= numberOfTxn %>) Transaction(s) exceed daily Shared Company Limit for ACH Sender <%= achSenderId %> <%= achSenderName %> for  <%= modifiedTransactionDate %>',
  'initiateForm.exceedUserCompanyMessage':
    '(<%= numberOfTxn %>) Transaction(s) exceed daily User Company Limit for ACH Sender <%= achSenderId %> <%= achSenderName %> for  <%= modifiedTransactionDate %>',
  'initiateForm.exceedOverAllTitle':
    'Change the transaction date or remove transactions to proceed.',
  'initiateForm.exceedCompanyTitle':
    'Change the transaction date or remove transactions from this ACH Sender to proceed.',
  'multiAchConfirmation.pageTitle': 'Payment Confirmation',
  'multiAchConfirmation.done': 'Done'
};
